export default __webpack_public_path__ + "static/media/help2.f2adb0b1.webp";